import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import ProtectedRoute from "./protectedRoutes";
import { history } from "../Redux/Store";

import LoginPage from "../Components/Login/login";
import LandingPage from "../Components/Landing/landing";
import RegisterPage from "../Components/Register/register";
import Home from "../Components/Home/home";
import JobsManagement from "../Components/Jobs";
import JobInfo from "../Components/Jobs/info";
import ChangePassword from "../Components/Login/changePassword";
import Notifications from "../Components/Notifications";
import DocumentVault from "../Components/DocumentVault";
import Checkout from "../Components/Checkout/checkout";
import AdditionalPayment from "../Components/AdditionalPayments/additionalPayment";
import AdditionalPaymentCheckout from "../Components/AdditionalPayments/additionalPaymentCheckout";
import FlyerNotifications from "../Components/FlyerNotifications/FlyerNotifications";
import Setting from "../Components/Setting/Setting";
import AdditionalPaymentList from "../Components/AdditionalPayments/additionalPaymentList";
import PaymentCheckout from "../Components/Checkout/paymentCheckout";
import AccessDeniedAlert from "../Components/Ui/403";
import BiometricBooking from "../Components/BiometricAppointment/biometricBooking";
import BiometricTracking from "../Components/BiometricAppointment/biometricTracking";
import BiometricCheckout from "../Components/BiometricAppointment/paymentCheckout";

const Routes = () => {
  const isLogged = localStorage.getItem("jwt") ? true : false;

  return (
    <BrowserRouter>
      <Switch history={history}>
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/landing" component={LandingPage} />
        <Route exact path="/login" component={LoginPage} />
        {/* <Route exact path="/biometricBooking" component={BiometricBooking} /> */}
        <Route exact path="/biometricTracking" component={BiometricTracking} />
        <Route exact path="/biometricCheckout" component={BiometricCheckout} />
        <Route exact path="/register" component={RegisterPage} />
        <Route exact path="/Payment/Checkout" component={PaymentCheckout} />
        <Route exact path="/access-denied" component={AccessDeniedAlert} />
        <ProtectedRoute
          exact
          path="/dashboard"
          loggedUser={true}
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/home"
          loggedUser={true}
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/jobs"
          loggedUser={isLogged}
          component={JobsManagement}
        />
        <ProtectedRoute
          exact
          path="/notifications"
          loggedUser={isLogged}
          component={Notifications}
        />
        <ProtectedRoute
          exact
          path="/jobs/:jobID"
          loggedUser={isLogged}
          component={JobInfo}
        />
        <ProtectedRoute
          exact
          path="/change-password"
          loggedUser={isLogged}
          component={ChangePassword}
        />
        <ProtectedRoute
          exact
          path="/documentVault"
          loggedUser={isLogged}
          component={DocumentVault}
        />
        <ProtectedRoute
          exact
          path="/checkout/:jobID"
          loggedUser={isLogged}
          component={Checkout}
        />
        <ProtectedRoute
          exact
          path="/additionalPayment/:jobID"
          loggedUser={isLogged}
          component={AdditionalPayment}
        />
        <ProtectedRoute
          exact
          path="/additionalPaymentCheckout/:requestId"
          loggedUser={isLogged}
          component={AdditionalPaymentCheckout}
        />
        <ProtectedRoute
          exact
          path="/setting"
          loggedUser={isLogged}
          component={Setting}
        />
        <ProtectedRoute
          exact
          path="/paydueslist"
          loggedUser={isLogged}
          component={AdditionalPaymentList}
        />
        <ProtectedRoute
          exact
          path="/flyerNotifications"
          loggedUser={isLogged}
          component={FlyerNotifications}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
